import { useLocations } from '@/api/location';
import type { LocationModel } from '@/generated';
import type { LocationInfo } from '@/models/locationInfo';
import { defineStore } from 'pinia';
import { computed, ref } from 'vue';

const useLocationsStore = defineStore(
    'locations',
    () => {
        const { data: allLocations, isPending: allLocationsPending } = useLocations();
        const selected = ref<LocationModel[]>([]);
        const locationInfo = ref<LocationInfo>({
            partnerCount: 0,
            orderCount: 0,
        });
        const selectedLocationIds = computed<number[]>(
            () =>
                selected?.value
                    ?.map((l: LocationModel): number => l?.id || 0)
                    ?.filter((n: number) => n > 0) || []
        );

        return {
            allLocations,
            allLocationsPending,
            selected,
            selectedLocationIds,
            locationInfo,
        };
    },
    {
        persist: {
            key: 'lo',
            storage: localStorage,
            pick: ['selected'],
        },
    }
);

export default useLocationsStore;
